import React, { useState } from 'react';

import {
  AppBar,
  Toolbar,
  Avatar,
  Typography,
  Menu,
  MenuItem,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DateRangeSelector from './DateRangeSelector';

const { useAuth } = require('../../utils/useAuth');

const useStyles = makeStyles((theme) => ({
  logoWrapper: {
    padding: theme.spacing(1),
  },
  logo: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  heading: {
    marginLeft: theme.spacing(1),
    flexGrow: 1,
  },
}));

const Header = ({ onReportGeneration, initials, isAdmin = false }) => {
  const classes = useStyles();
  const { signout } = useAuth();

  const [anchorEl, setAnchorEl] = useState(false);
  const [dateRangeOpen, setDateRangeOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <AppBar position="fixed" color="default">
        <DateRangeSelector
          isOpen={dateRangeOpen}
          onClose={() => setDateRangeOpen(false)}
          onSubmit={onReportGeneration}
        />
        <Toolbar>
          <div className={classes.logoWrapper}>
            <a href="/">
              <img className={classes.logo} alt="TSNW Logo" src="/logo.png" />
            </a>
          </div>
          <Typography className={classes.heading} variant="h5">
            Volunteer Time Tracker
          </Typography>
          <Avatar>{initials}</Avatar>
          <KeyboardArrowDownIcon
            aria-controls="avatar-menu"
            aria-haspopup="true"
            onClick={handleClick}
          />
          <Menu
            id="avatar-menu"
            anchorEl={anchorEl}
            keepMounted
            open={!!anchorEl}
            onClose={handleClose}
          >
            {isAdmin && (
              <div>
                <MenuItem component="a" href="/manage-events">
                  Manage Events
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setDateRangeOpen(true);
                    setAnchorEl(null);
                  }}
                >
                  Generate Report
                </MenuItem>
              </div>
            )}
            <MenuItem onClick={signout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
